import script from "./StoriesGroupSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesGroupSlider.vue?vue&type=script&setup=true&lang=js"

import "./StoriesGroupSlider.vue?vue&type=style&index=0&id=99a3feaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99a3feaa"]])

export default __exports__